module.exports = __webpack_public_path__ + "img/kelpie-1.839c2c86.jpg";